import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from "react";
import { createPortal } from "react-dom";
import { UiCrossIcon } from "@jti/brand-icons/ui-cross";
import { useOutsideClick } from "../../../hooks/useOutsideClick";
import styles from "./PopupVideoDialog.module.scss";
export const PopupVideoDialog = ({ videoPlayer, handleClose, isPopupOpen }) => {
    const containerRef = useRef(null);
    useOutsideClick(containerRef, handleClose, {
        excludeSelectors: [`.${styles.closeIcon}`],
    });
    if (!isPopupOpen) {
        return null;
    }
    return createPortal(_jsxs("div", { className: styles.dialogContainer, "data-testid": "popupVideoDialog", children: [_jsx(UiCrossIcon, { role: "button", className: styles.closeIcon, onClick: handleClose }), _jsx("div", { ref: containerRef, className: styles.videoContainer, children: videoPlayer })] }), document.body);
};
//# sourceMappingURL=PopupVideoDialog.js.map